import { Component, Input, ChangeDetectionStrategy, OnInit, signal } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-iframe',
    templateUrl: './iframe.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IframeComponent implements OnInit {
    @Input() src: string;
    isSourceReady = signal(false);
    trustedSource: SafeResourceUrl;

    constructor(private sanitizer: DomSanitizer) { }

    ngOnInit(): void {
        this.trustedSource = this.sanitizer.bypassSecurityTrustResourceUrl(this.src);
        this.isSourceReady.set(true);
    }
}
